import { EChatActionTypes } from '@r1-frontend/entities/Chat/store/constants/actions';
import { initialState, TChatState } from '@r1-frontend/entities/Chat/store/initialState';

import { InferValueTypes } from '@r1-frontend/shared/types/Redux';

import * as actionCreators from './actions';

export type TActions = ReturnType<InferValueTypes<typeof actionCreators>>;

const reducer = (state: TChatState = initialState, action: TActions) => {
    switch (action.type) {
        case EChatActionTypes.OPEN_CHAT: {
            return {
                ...state,
                isOpen: true,
            };
        }
        case EChatActionTypes.CLOSE_CHAT: {
            return {
                ...state,
                isOpen: false,
            };
        }
        case EChatActionTypes.CHANGE_LOADED_CHAT: {
            return {
                ...state,
                isLoaded: action.payload.isLoaded,
            };
        }
        default: {
            return state;
        }
    }
};

export default reducer;
